import { BaseRecord } from "./_base_record";

export class CourseAttendanceRecord extends BaseRecord {}
